export default __webpack_public_path__ + "static/media/transaction.e839eeb0.png";